export class OfferCardHelpers {
  static generateIndexesForRow(
    rowIndex: number,
    maxItemsPerRow: number,
    itemsAmount: number,
  ): number[] {
    const indexesPerRow: number[] = [];
    const startIndex: number = rowIndex * maxItemsPerRow;

    for (
      let i = startIndex;
      i < Math.min(startIndex + maxItemsPerRow, itemsAmount);
      i++
    ) {
      indexesPerRow.push(i);
    }

    return indexesPerRow;
  }

  static getMaxItemsAmountPerRow(width: number): number {
    if (width <= 561) {
      return 1;
    }

    const cardMinWidth = 166;
    const columnGap = 18;
    const maxGridWidth = 1400;
    const maxItems = 6;
    const usableWidth = Math.min(width, maxGridWidth);
    const calculatedItems = Math.floor(
      (usableWidth + columnGap) / (cardMinWidth + columnGap),
    );

    return Math.min(maxItems, Math.max(1, calculatedItems));
  }

  static getRowsAmount(itemsAmount: number, width: number): number {
    const maxItemsPerRow: number = this.getMaxItemsAmountPerRow(width);
    const extraRow: boolean = itemsAmount % maxItemsPerRow !== 0;

    return Math.floor(itemsAmount / maxItemsPerRow) + (extraRow ? 1 : 0);
  }
}
